import { render } from "./Pagina.vue?vue&type=template&id=81f0cdda"
import script from "./Pagina.vue?vue&type=script&lang=js"
export * from "./Pagina.vue?vue&type=script&lang=js"
script.render = render

export default script